import type { ContinuationTarget } from "~/helpers/pendingIntentLifecycle";

import { isCleanExactPath } from "~/helpers/pendingIntentLifecycle";

export type { ContinuationTarget } from "~/helpers/pendingIntentLifecycle";

export interface SourceCapture<TDraft, TListContext> {
	checkpoint: TDraft;
	listContext: TListContext;
}

export interface SourceCheckpointAdapter<TDraft, TListContext> {
	capture: () => SourceCapture<TDraft, TListContext>;
	restore: (listContext: TListContext) => void;
	seed: (checkpoint: TDraft) => TDraft;
}

export interface ReceiverIdentityAdapter {
	buildCleanPath: (target: ContinuationTarget) => string;
	matchesRoute: (pathname: string) => ContinuationTarget | null;
}

export const receiverChildEditorKey = (panelId: string, target: ContinuationTarget): string =>
	`${panelId}:${target.targetKind}:${target.targetId}`;

const buildReceiverPath = (adapter: ReceiverIdentityAdapter, target: ContinuationTarget): string | null => {
	const path = adapter.buildCleanPath(target);
	return isCleanExactPath(path) ? path : null;
};

export default buildReceiverPath;
